import { create } from 'zustand';
import settings from '@settings';

interface ColorState {
  menu: string;
  logo: string;
  navigation: string;
  legal: string;
  leftContentColor: 'dark' | 'light';
  rightContentColor: 'dark' | 'light';
  setColor: (key: keyof Omit<ColorState, 'setColor'>, value: string) => void;
  setLeftContentColor: (value: 'dark' | 'light') => void;
  setRightContentColor: (value: 'dark' | 'light') => void;
}

export const useColorStore = create<ColorState>((set) => ({
  menu: settings.colors.dark,
  logo: settings.colors.dark,
  navigation: settings.colors.dark,
  legal: settings.colors.dark,
  leftContentColor: 'dark',
  rightContentColor: 'dark',
  setColor: (key, value) => set((state) => ({ ...state, [key]: value })),
  setLeftContentColor: (value: 'dark' | 'light') => set((state) => ({ ...state, leftContentColor: value })),
  setRightContentColor: (value: 'dark' | 'light') => set((state) => ({ ...state, rightContentColor: value }))
}))
